var _class, _temp;

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React, { Component } from 'react';
import t from 'prop-types'; // import { connect } from 'react-redux';

import ReactQuill, { Quill } from 'react-quill';
import Toolbar from './toolbar'; // see https://stackoverflow.com/questions/38623716/how-to-add-custom-font-sizes-to-quilljs-editor

var Size = Quill.import('attributors/style/size');
Size.whitelist = ['0.6em', '1em', '1.5em', '3em'];
Quill.register(Size, true);
var nextEditorId = 0;

var getNextEditorId = function getNextEditorId() {
  return nextEditorId++;
};

var EditorTexto = (_temp = _class = function (_Component) {
  _inherits(EditorTexto, _Component);

  function EditorTexto(props) {
    _classCallCheck(this, EditorTexto);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.handleGuardar = function () {
      _this.props.onModificar(_this.state.textoHtml);
    };

    _this.handleCancelar = function () {
      _this.props.onCancelar();
    };

    _this.handleChange = function (value) {
      _this.setState({
        textoHtml: value
      });
    };

    var toolbarId = 'toolbar' + getNextEditorId();
    _this.state = {
      toolbarId: toolbarId,
      textoInicial: props.textoHtml,
      textoHtml: props.textoHtml,
      modules: {
        toolbar: {
          container: '#' + toolbarId,
          handlers: {
            // 'tamFuente': this.handleTamFuente,
            'guardar': _this.handleGuardar,
            'cerrar': _this.handleCancelar
          }
        }
      },
      ajustarALaDerecha: 0
    };
    return _this;
  } //     handleTamFuente = (value) => {
  //         const selection = this.quill.getEditorSelection();
  //         // console.log(this.quill.getEditor());
  //         this.quill.getEditor().formatText(selection.index, selection.length, {'size': value})
  // //        this.quill.getEditor().removeFormat(selection.index, selection.length);
  //     }


  EditorTexto.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
    return this.state.ajustarALaDerecha !== nextState.ajustarALaDerecha;
  };

  EditorTexto.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    if (!this.root) {
      return;
    }

    var rootRect = this.root.getBoundingClientRect();
    var parentRect = this.root.parentNode.getBoundingClientRect();
    var ajustarALaDerecha = 100 * Math.max(rootRect.right - parentRect.right, 0) / parentRect.width;

    if (ajustarALaDerecha !== this.state.ajustarToolbar) {
      window.setTimeout(function () {
        return _this2.setState({
          ajustarALaDerecha: ajustarALaDerecha
        });
      }, 50);
    }
  };

  EditorTexto.prototype.render = function render() {
    var _this3 = this;

    var _props = this.props,
        x = _props.x,
        y = _props.y,
        textoHtml = _props.textoHtml,
        offset = _props.offset,
        clase = _props.clase,
        tamFuenteBase = _props.tamFuenteBase;
    var stylePosicion = {
      left: x + offset.x - this.state.ajustarALaDerecha + '%',
      top: y + offset.y + '%',
      position: 'absolute',
      minWidth: 325,
      zIndex: 11,
      pointerEvents: "auto"
    };
    var styleAreaEdicion = {
      fontSize: tamFuenteBase + 'px'
    };
    return React.createElement('div', {
      ref: function ref(root) {
        return _this3.root = root;
      },
      style: stylePosicion
    }, React.createElement(ReactQuill, {
      ref: function ref(quill) {
        return _this3.quill = quill;
      },
      theme: 'snow',
      defaultValue: textoHtml,
      onChange: this.handleChange,
      modules: this.state.modules
    }, React.createElement('div', {
      className: clase + ' textoUsuario',
      style: styleAreaEdicion
    })), React.createElement(Toolbar, {
      id: this.state.toolbarId
    }));
  };

  return EditorTexto;
}(Component), _class.defaultProps = {
  x: 0,
  y: 0,
  textoHtml: '',
  offset: {
    x: 0,
    y: 0
  }
}, _temp);
EditorTexto.propTypes = process.env.NODE_ENV !== "production" ? {
  /** posicion horizontal del editor relativa a su contenedor y en porcentaje, ejemplo: 10 para 10% */
  x: t.number.isRequired,

  /** posicion vertical del editor relativa a su contenedor y en porcentaje, ejemplo: 10 para 10% */
  y: t.number.isRequired,

  /** texto html */
  textoHtml: t.string.isRequired,

  /** tamaño 'normal' de la fuente en pixels. 1em será tratado como de este tamaño. */
  tamFuenteBase: t.number.isRequired,

  /** offset que se suma a las coordenadas para renderizar el componente. Opcional */
  offset: t.shape({
    x: t.number.isRequired,
    y: t.number.isRequired
  }),
  clase: t.string,
  // función para disparar las acciones (integración con Redux) 
  // dispatch: t.func.isRequired
  // onCancelar: t.func.isRequired,
  onModificar: t.func.isRequired,
  onCancelar: t.func
} : {};
export default EditorTexto;